export default __webpack_public_path__ + "static/content-1cdc4e3a778a58f3364c7af5d36e8fc6.jpg";